<form [formGroup]="purchaseReceiptSearchForm" (ngSubmit)="searchPurchaseReceipt()">
    <h3>Lookup Purchase Receipt</h3>
    <mat-form-field appearance="fill" style="width:95vw;">
        <mat-label>Purchase Order Number</mat-label>
        <input matInput formControlName="PONbr" required />
    </mat-form-field>

    <mat-error *ngIf="purchaseOrderFormError">
        <mat-icon>error</mat-icon> {{purchaseOrderFormError.message}}
    </mat-error>

    <div style="display:flex;justify-content:space-between;">
        <span style="display:flex;"></span>
        <button mat-raised-button color="primary" style="display:flex;
  justify-content: flex-end;">Find Receipt</button>
    </div>

    <button mat-raised-button *ngFor="let receipt of searchReceipts"
        (click)="processPurchaseReceipt(receipt.ReceiptNbr)">{{receipt.ReceiptNbr}} - {{receipt.Date | date: 'M/d/yy'}}
        - Receipt Qty: {{receipt.ReceivedQty}}</button>
</form>

<mat-divider style="margin:1em 0;"></mat-divider>

<form [formGroup]="processPurchaseReceiptForm" (ngSubmit)="processPurchaseReceipt()">
    <h3>Process Purchase Receipt</h3>
    <mat-form-field appearance="fill" style="width:95vw;">
        <mat-label>Receipt Number</mat-label>
        <input matInput formControlName="ReceiptNbr" required />
    </mat-form-field>

    <mat-error *ngIf="purchaseReceiptFormError">
        <mat-icon>error</mat-icon> {{purchaseReceiptFormError.message}}
    </mat-error>

    <div style="display:flex;justify-content:space-between;">
        <span style="display:flex;"></span>
        <button mat-raised-button color="primary" style="display:flex;
  justify-content: flex-end;">Process Receipt</button>
    </div>
</form>